import React from "react";
import LoadingButton, { LoadingButtonProps } from "@mui/lab/LoadingButton";

export const Button: React.FC<LoadingButtonProps> = props => (
  <LoadingButton {...props} />
);
